var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { merge } from 'lodash';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { css, styled } from "../../utils";
import defaultRenderers from "./renderers";
import ParagraphRenderer from "./renderers/ParagraphRenderer";
var StyledMarkdown = styled(ReactMarkdown)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    * {\n      color: ", ";\n    }\n\n    a {\n      display: inline;\n    }\n  "], ["\n    * {\n      color: ", ";\n    }\n\n    a {\n      display: inline;\n    }\n  "])), colors.lightBlack);
});
var LinkRenderer = defaultRenderers.link;
var Markdown = function (_a) {
    var onLinkClick = _a.onLinkClick, renderers = _a.renderers, props = __rest(_a, ["onLinkClick", "renderers"]);
    return (React.createElement(StyledMarkdown, __assign({}, props, { renderers: merge(__assign(__assign({}, defaultRenderers), { paragraph: function (paragraphProps) { return React.createElement(ParagraphRenderer, __assign({}, props, paragraphProps)); }, link: function (linkProps) { return React.createElement(LinkRenderer, __assign({}, props, linkProps, { onClick: onLinkClick })); } }), renderers) })));
};
export default Markdown;
var templateObject_1;
//# sourceMappingURL=index.js.map